import Image from 'next/image'
// import { ContainerWrapper } from '../Container'
import StepsSection from '../StepsSection'
import HeroTopHeading from '../Headings/HeroTopHeading'
import HeroHeading from '../Headings/HeroHeading'
import BookACallPremiumList from '../Buttons/Specials/BookACallPremiumList'

const steps = [
    {
        number: 1,
        title: 'Book a Call',
        description: 'Select a time to get started.',
    },
    {
        number: 2,
        title: 'List Building Working Call',
        description:
            'We call you to build your lead list using your investment criteria.',
    },
    {
        number: 3,
        title: 'Receive Your List',
        description:
            'Receive a list tailored to your specific requirements, ready to boost your marketing performance.',
    },
]

export default function HeroSection({ Modal, modalProps }) {
    return (
        <div className="container -my-10 mx-auto">
            <div className="flex flex-col md:flex-row items-start justify-between p-4 px-8 md:p-8">
                <div className="w-full md:w-6/12">
                    <HeroTopHeading>PREMIUM LEAD LISTS</HeroTopHeading>
                    <HeroHeading>
                        {' '}
                        Find Your Perfect Investment Opportunity{' '}
                    </HeroHeading>
                    <div className="space-y-10 md:py-10 py-4">
                        <p className="text-xl md:text-2xl font-semibold">
                            Get Access to High-Quality Lists Tailored to Your
                            Needs
                        </p>
                        <div className="hidden md:block">
                            <StepsSection steps={steps} />
                        </div>
                        <div className="flex md:hidden w-full md:w-5/12 mt-8 md:mt-0  justify-center">
                            <Image
                                src="/assets/lead-lists/hero.png" // Replace with your actual image path
                                alt="Hero Image, A smiling man in a blue button-down shirt is working on a silver laptop at a desk."
                                title="Professional man working on a laptop."
                                width={580}
                                height={599}
                                className="rounded-lg"
                            />
                        </div>
                        <div className="w-full md:w-10/12">
                            <BookACallPremiumList
                                Modal={Modal}
                                modalProps={modalProps}>
                                <span className="uppercase">Start now</span>
                            </BookACallPremiumList>
                        </div>

                        <div className="block md:hidden">
                            <StepsSection steps={steps} />
                        </div>
                    </div>
                </div>
                <div className="w-full hidden md:flex md:w-5/12 mt-8 md:mt-0 justify-center">
                    <Image
                        src="/assets/lead-lists/hero.png" // Replace with your actual image path
                        alt="Hero Image, A smiling man in a blue button-down shirt is working on a silver laptop at a desk."
                        title="Professional man working on a laptop."
                        width={580}
                        height={599}
                        className="rounded-lg"
                    />
                </div>
            </div>
        </div>
    )
}
